<template>
  <button
    type="button"
    class="company-switcher__trigger"
    :class="{ 'is-open': open }"
    aria-haspopup="listbox"
    :aria-expanded="open ? 'true' : 'false'"
    :aria-controls="open ? panelId : null"
    @click="$emit('toggle')"
    @keydown.down.prevent="$emit('open')"
    @keydown.up.prevent="$emit('open')"
  >
    <span aria-hidden="true" class="company-switcher__trigger-icon">
      <lucide-icon :icon="icons.building" :size="16" />
    </span>
    <span class="company-switcher__trigger-text">
      <span class="company-switcher__trigger-label">{{ $t('empresa') }}</span>
      <span class="company-switcher__trigger-value">{{
        label || $t('selecioneempresa')
      }}</span>
    </span>
    <lucide-icon
      :icon="icons.chevronsUpDown"
      :size="16"
      aria-hidden="true"
      class="company-switcher__trigger-chevron"
    />
  </button>
</template>

<script>
import { Building2, ChevronsUpDown } from 'lucide'
import LucideIcon from '@/components/LucideIcon'

export default {
  name: 'CompanySwitcherTrigger',
  components: { LucideIcon },
  props: {
    label: {
      type: String,
      required: true
    },
    panelId: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icons() {
      return {
        building: Building2,
        chevronsUpDown: ChevronsUpDown
      }
    }
  }
}
</script>
